module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/login/2_regent-45764d5def05a7347a3943ec8a6f9aa6.png";